import { useState } from "react";
import WorkflowCatalogSetup from "./WorkflowCatalogSetup";
import WorkflowCatalogCarousel from "./WorkflowCatalogCarousel";
import WorkflowCatalogCardView from "./WorkflowCatalogCardView";
import { useNavigate } from "react-router-dom";

const WorkflowCatalog = () => {
  const navigate = useNavigate();
  const [isCreateALgoRiskClicked, setisCreateAlgoRiskClicked] =
    useState<boolean>();

  if (isCreateALgoRiskClicked === true) {
    navigate("/workflow-catalog/new-workflow/algo-risk");
  } else if (isCreateALgoRiskClicked === false) {
    navigate("/workflow-catalog/new-workflow/algo-performance");
  }
  return (
    <>
      <WorkflowCatalogCarousel
        onCreateClick={(isAlgoRisk) => {
          setisCreateAlgoRiskClicked(isAlgoRisk);
        }}
      />
      <WorkflowCatalogSetup />
      <WorkflowCatalogCardView
        onCreateClick={(isAlgoRisk: boolean) =>
          setisCreateAlgoRiskClicked(isAlgoRisk)
        }
      />
    </>
  );
};

export { WorkflowCatalog };
